import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import {forEach} from 'ramda';
import $ from 'jquery';

const selectors = {
	el: '.js-form',
	error: '.js-form-error',
	submit: '.js-form-submit',
	input: {
		error: '.js-input-error',
		el: '.js-input'
	}
};

const states = {
	success: 'form_success'
};

const classes = {
	error: {
		visible: 'form__error_visible'
	}
};

const getNodesLength = nodeList => nodeList.length;

const pushToArr = arr => item => arr.push(item.dataset.error);

const getArr = inputs => {
	const text = [];
	forEach(pushToArr(text), inputs);
	return text;
};

const showError = (inputs, form) => {
	const length = getNodesLength(inputs);
	if (!length) {
		return;
	}
	let text = '';
	const error = form.querySelector(selectors.error);
	const errorWrap = error.parentElement;
	errorWrap.classList.add(classes.error.visible);
	switch (length) {
		case 1:
			text = getArr(inputs).toString().toLowerCase();
			error.textContent = `Осталось заполнить поле «${text}»`;
			break;
		case 2:
			text = getArr(inputs).join('» и поле «').toLowerCase();
			error.textContent = `Осталось заполнить поле «${text}»`;
			break;
		default:
			text = 'Заполните все поля, пожалуйста';
			error.textContent = `${text}`;
			break;
	}
};

const onClick = e => {
	const target = e.target;
	const errors = target.querySelectorAll(selectors.input.error);
	showError(errors, target);
};

const onSubmit = e => {
	e.preventDefault();
	const target = e.target;
	target.classList.add(states.success);
};

const setHandlers = () => {
	bindEvent(selectors.el, 'submit', onSubmit);
	$(selectors.el).on('invalid', onClick);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/form/index.js